import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import { initializeAppCheck, ReCaptchaV3Provider, ReCaptchaEnterpriseProvider } from 'firebase/app-check';

// Firebase configuration
// Get this from Firebase Console > Project Settings > General > Your apps > Web apps
const firebaseConfig = {
	apiKey: "AIzaSyD9CO9PMJVqrnM289vyIBWAkNtBD2KWgbg", // This should be a web-specific API key
	authDomain: "equityworkx.firebaseapp.com",
	projectId: "equityworkx",
	storageBucket: "equityworkx.firebasestorage.app",
	messagingSenderId: "506667541880",
	appId: "1:506667541880:web:683080aff0649a8ba7948d", // This should be a web-specific app ID
	measurementId: "G-C7QDBPTB3G"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize App Check with reCAPTCHA v3
// Can be temporarily disabled by setting REACT_APP_DISABLE_APP_CHECK=true
const disableAppCheck = process.env.REACT_APP_DISABLE_APP_CHECK === 'true';

if (typeof window !== 'undefined' && !disableAppCheck) {
	if (process.env.NODE_ENV === 'production') {
		// PRODUCTION: Use reCAPTCHA (v3 or Enterprise)
		// IMPORTANT: The reCAPTCHA site key MUST include your custom domain in authorized domains
		// Get this from: https://console.cloud.google.com/security/recaptcha
		// Click on your site key > Settings > Add your custom domain
		const appCheckToken = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '6Lezs8srAAAAAETOGVuQ0NioQ4wkcHQsj56fQnLn';
		const useEnterprise = process.env.REACT_APP_RECAPTCHA_ENTERPRISE === 'true';

		try {
			// Use Enterprise or v3 provider based on configuration
			const provider = useEnterprise 
				? new ReCaptchaEnterpriseProvider(appCheckToken)
				: new ReCaptchaV3Provider(appCheckToken);
			
			initializeAppCheck(app, {
				provider,
				isTokenAutoRefreshEnabled: true
			});
			console.log(`✅ App Check initialized with reCAPTCHA ${useEnterprise ? 'Enterprise' : 'v3'}`);
		} catch (error) {
			console.error('❌ Failed to initialize App Check:', error);
			console.error('This may be due to reCAPTCHA not being configured for your domain');
		}
	} else {
		// DEVELOPMENT: Debug mode
		console.log('🔧 App Check disabled in development');
	}
} else if (disableAppCheck) {
	console.warn('⚠️ App Check is DISABLED via environment variable');
	console.warn('This should only be temporary - enable App Check for security');
}

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Note: Emulators disabled - using production Firebase services only

export default app; 